export const GetCurrencies = async () =>
  fetch('/api/public/currencies', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
